import { LicenseIcon } from '@hugeicons-pro/core-solid-rounded'

import { HugeiconsIcon } from '@hugeicons/react'

import { LevelFooter } from '../Footer'
import { HUD } from '../HUD'

import { useLevelContext } from '@/features/level-play'
import { Step, useFlow } from '@/shared/lib/steps-flow'
import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/ui/Button'

import styles from './styles.module.scss'

interface GameStepIntroProps {
  step: Step
}

export const StepIntro = ({ step }: GameStepIntroProps) => {
  const { goNext } = useFlow()
  const { level } = useLevelContext()

  const challenge = level?.active_challenges.find(
    c => c.id === step.challengeId
  )

  return (
    <HUD.Card>
      <HUD.Header challenge={challenge} />
      <HUD.Body className="">
        <div className="p-4 rounded-lg bg-jacaranda/20 min-h-[300px] w-full">
          <div className="flex items-end gap-1 mb-2">
            <HugeiconsIcon
              icon={LicenseIcon}
              className="text-begonia"
              size={20}
            />
            <span className="block font-sans font-bold leading-none uppercase text-begonia text-md">
              Introdução
            </span>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: challenge?.intro || ''
            }}
            className={cn(
              'text-lg md:text-2xl mb-10 text-dark font-semibold block',
              styles.introContent
            )}
          />
        </div>
      </HUD.Body>
      <LevelFooter>
        <Button
          type="button"
          onClick={goNext}
          className="w-full font-bold relative z-10"
        >
          Continuar
        </Button>
      </LevelFooter>
    </HUD.Card>
  )
}
